import moment from 'moment'
import 'moment/locale/es-mx'
import { MIN_DATE } from '@/utils/minDatesFilters'
import { nowDay } from '@/utils/moment'

export default {
  install(Vue) {
    Vue.prototype.$MIN_DATE = MIN_DATE
    Vue.prototype.$MAX_DATE = nowDay()
    Vue.$moment = moment
    Object.defineProperty(Vue.prototype, '$moment', {
      get () {
        return moment
      }
    })
  }
}
